package br.com.texeratx.boardgametimeapp.domain.usecases.player

import br.com.texeratx.boardgametimeapp.data.repository.PlayerRepository

class DeletePlayerUseCase(
    private val repository: PlayerRepository
) {
    suspend operator fun invoke(playerId: Long): Result<Unit> {
        return repository.deletePlayer(playerId)
    }
}
